import React from 'react';
import WipAppsheetAccountsBrowserPage from './wip/WipAppsheetAccountsBrowserPage.jsx';

const AppsheetAccountsPage = () => <WipAppsheetAccountsBrowserPage />;

export default AppsheetAccountsPage;
